function Error() {
    return <div>Sorry bro...</div>
}

export default Error
